import { render, staticRenderFns } from "./LoaderOne.vue?vue&type=template&id=275c7d20&scoped=true&"
var script = {}
import style0 from "./LoaderOne.vue?vue&type=style&index=0&id=275c7d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c7d20",
  null
  
)

export default component.exports